/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Incidents API
 * AV Services Incidents management API
 * OpenAPI spec version: 1.0
 */

export interface DeviceAdditionalAttributeDto {
  name: string;
  friendlyName: string;
  attributeType: string;
  /** @nullable */
  value?: string | null;
  isManual: boolean;
}
